import { DesignTokensProvider, GlobalStyles } from '@mgmresorts/mgm-ui';
import { ViewportContextProvider } from '@mgmresorts/mgm-ui-providers';
import React from 'react';

import { FlagsValueProvider } from './common/context/FlagsValueContext';
import { useLogrocketTracking } from './hooks/useLogrocketTracking';
import { AnalyticsServiceProvider } from './utils/analytics/analytics';
import { AuthContextProvider } from './utils/auth/AuthProvider';
import { OfflineContextProvider } from './utils/offlineContext';
import { PersistentParametersContextProvider } from './utils/persistParameterContext';
import { UserAccountContextProvider } from './utils/userAccountContext';

export const ContextWrappers = (props: { children: React.ReactNode | React.ReactNodeArray }) => {
  useLogrocketTracking();

  return (
    <ViewportContextProvider>
      <AnalyticsServiceProvider>
        <PersistentParametersContextProvider>
          <DesignTokensProvider dev={process.env.REACT_APP_ENVIRONMENT !== 'prod'}>
            <GlobalStyles />
            <OfflineContextProvider>
              <FlagsValueProvider>
                <AuthContextProvider>
                  <UserAccountContextProvider>{props.children}</UserAccountContextProvider>
                </AuthContextProvider>
              </FlagsValueProvider>
            </OfflineContextProvider>
          </DesignTokensProvider>
        </PersistentParametersContextProvider>
      </AnalyticsServiceProvider>
    </ViewportContextProvider>
  );
};
